import React from 'react';
import { Grid } from '@nextiva/next-ui-components';

export const ShadowDomainsTable = () => {
  const rows = [];

  for (let i = 0; i < 8; i++) {
    rows.push(
      <div
        className="m-shadow-domains-list__shadow__table_row"
        key={`shadow_domains_list${i}`}
      >
        <Grid container>
          <Grid item xs={4}>
            <div className="m-shadow-domains-list__shadow__labels__domain"></div>
          </Grid>
          <Grid item xs={4}>
            <div className="m-shadow-domains-list__shadow__labels__status"></div>
          </Grid>
        </Grid>
      </div>,
    );
  }

  return rows;
};
